import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Layouts
import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';

// Application Components
import { InicioComponent } from './views/inicio/inicio.component';
import { LogoutComponent } from './views/auth/logout/logout.component';
import { RegistroEstablecimientoComponent } from './views/form-registro/registro/registro-establecimiento.component';

// Guards
import { UnsavedChangesGuard } from './views/form-component/unsaved-changes.guard';
import { PostRegistroProductosComponent } from './views/lista-procesos/lista-productos/post-registro/post-registro-productos.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'inicio',
    pathMatch: 'full',
  },
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'auth',
        loadChildren: () =>
          import('./views/auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: '',
    component: AdminLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./views/lista-procesos/lista.module').then(
            (m) => m.ListaModule
          ),
      },
      {
        path: 'user',
        loadChildren: () =>
          import('./views/user/user.module').then((m) => m.UserModule),
      },
      {
        path: 'inicio',
        component: InicioComponent,
      },
      {
        path: 'auth/logout',
        component: LogoutComponent,
      },
      {
        path: ':inscripcion/:proceso',
        component: RegistroEstablecimientoComponent,
        canDeactivate: [UnsavedChangesGuard],
      },
      {
        path: 'post-registro/:tipo/:area',
        component: PostRegistroProductosComponent,
      },
      {
        path: 'consulta/:proceso/:id',
        component: RegistroEstablecimientoComponent,
        canDeactivate: [UnsavedChangesGuard],
      },
    ],
  },
  { path: '**', component: InicioComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
